// extracted by mini-css-extract-plugin
export default {"BrowseListCard__card":"BrowseListCard_BrowseListCard__card__ZDUxN","BrowseListCard__container":"BrowseListCard_BrowseListCard__container__MWVjM"};